import React, { useEffect, useState, useCallback, useRef } from "react";
import {
    Modal, Button, Badge, Card, Row, Col,
    Container, Spinner, ButtonGroup,
    ToggleButton, Form, InputGroup
} from 'react-bootstrap';
import { api } from '../../services/api.js';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import Foto from "../Components/Foto";
import PdfFullscreen from "../Components/Foto/pdf.jsx";
import ModalNovoChamado from "./ModalNovoChamado";
import { toast } from 'react-toastify';
import './chamado.css';
import Swal from 'sweetalert2';


function CentralChamados() {
    const [chamados, setChamados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtroTipo, setFiltroTipo] = useState('loja');
    const [filtroStatus, setFiltroStatus] = useState('Todos');
    const [loadingDetalhes, setLoadingDetalhes] = useState(false);
    const [fullscreenPdf, setFullscreenPdf] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");
    const [urlParaVisualizar, setUrlParaVisualizar] = useState("");

    const [showDetalhes, setShowDetalhes] = useState(false);
    const [showNovo, setShowNovo] = useState(false);

    const [chamadoSelecionado, setChamadoSelecionado] = useState(null);
    const [interacoes, setInteracoes] = useState([]);
    const [anexosAbertura, setAnexosAbertura] = useState([]);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const [pdfSelecionado, setPdfSelecionado] = useState(null);

    const [novaMsg, setNovaMsg] = useState("");
    const [anexosNovos, setAnexosNovos] = useState([]);
    const [enviandoInt, setEnviandoInt] = useState(false);

    const scrollRef = useRef(null);
    const chapa = localStorage.getItem("chapa");
    const lojap = localStorage.getItem("loja");

    const lojasPermitidas = JSON.parse(localStorage.getItem("lojasPermitidas") || "[]");
    const [lojaSelecionada, setLojaSelecionada] = useState(lojap);
    const lojaUser = lojaSelecionada;
    console.log('Loja User: ' + lojap);

    //avaliacao
    const [notaAvaliacao, setNotaAvaliacao] = useState(10); // Inicia com 10 por padrão
    const [concordaSolucao, setConcordaSolucao] = useState(null); // null, 'SIM' ou 'NAO'


    // 🔥 ADICIONE ESTAS DUAS LINHAS AQUI:
    const [pagina, setPagina] = useState(1);
    const [temMais, setTemMais] = useState(true);
    const [segundosParaAtualizar, setSegundosParaAtualizar] = useState(180); // 180s = 3 min



    //limpar modal
    useEffect(() => {
        if (showDetalhes) {
            // Limpa os campos sempre que o modal de detalhes abrir
            setNovaMsg("");
            setAnexosNovos([]);
            setNotaAvaliacao(10);
            setConcordaSolucao(null);
        }
    }, [showDetalhes]);



    // Função para formatar Nome: Primeiro nome + Camel Case
    const formatarNomePrimeiro = (nome) => {
        if (!nome) return "";
        const primeiro = nome.split(" ")[0].toLowerCase();
        return primeiro.charAt(0).toUpperCase() + primeiro.slice(1);
    };

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [interacoes, showDetalhes]);


    const formatarData = (isoString) => {
        if (!isoString) return "";

        const data = isoString.replace("Z", "");
        const dt = new Date(data);

        const dia = String(dt.getDate()).padStart(2, "0");
        const mes = String(dt.getMonth() + 1).padStart(2, "0");
        const ano = dt.getFullYear();
        const hora = String(dt.getHours()).padStart(2, "0");
        const minuto = String(dt.getMinutes()).padStart(2, "0");
        const segundo = String(dt.getSeconds()).padStart(2, "0");


        return `${dia}/${mes}/${ano} - ${hora}:${minuto}:${segundo}`;
    };

    // 1. Certifique-se de que os estados de página estão aqui


    // 2. A função com os parâmetros declarados corretamente
    {/*const carregarChamados = useCallback(async (novaPagina = 1, acumular = false) => {
        // Agora 'novaPagina' e 'acumular' existem para o restante do código
        if (!acumular) setLoading(true);

        try {
            const pUser = filtroTipo === 'meus' ? chapa : '';
            const pLoja = filtroTipo === 'meus' ? -1 : lojaSelecionada;

            let statusId = -1;
            let usr = "";
            if (filtroStatus === "Abertos") {
                statusId = 0; usr = "T";
            } else if (filtroStatus === "Aguardando Retorno") {
                usr = "U";
            } else if (filtroStatus === "Aguardando Avaliação") {
                statusId = 90; usr = "X";
            } else if (filtroStatus === "Fechados") {
                statusId = 99; usr = "X";
            } else if (filtroStatus === "Cancelados") {
                statusId = 98; usr = "X";
            }

            const res = await api.get(`/chamados`, {
                params: {
                    depend: usr,
                    loja: pLoja,
                    usuario: pUser,
                    status: statusId,
                    setor: -1,
                    pagina: novaPagina, // Usando o parâmetro aqui
                    limite: 15
                }
            });

            const novosChamados = Array.isArray(res.data) ? res.data : [];

            if (acumular) { // Usando o parâmetro aqui
                setChamados(prev => [...prev, ...novosChamados]);
            } else {
                setChamados(novosChamados);
            }

            setTemMais(novosChamados.length === 15);
            setPagina(novaPagina);

        } catch (err) {
            console.error(err);
            if (!acumular) toast.error("Erro ao carregar lista de chamados");
        } finally {
            setLoading(false);
        }
    }, [filtroTipo, filtroStatus, lojaSelecionada]);*/}

    const carregarChamados = useCallback(async (novaPagina = 1, acumular = false) => {
        // Se não for acumular (scroll), limpamos a lista e mostramos o loading
        if (!acumular) {
            setLoading(true);
            // Opcional: setChamados([]); // Se quiser limpar a tela antes de carregar os novos 15
        }

        try {
            const pUser = filtroTipo === 'meus' ? chapa : '';
            const pLoja = filtroTipo === 'meus' ? -1 : lojaSelecionada;

            let statusId = -1;
            let usr = "";
            if (filtroStatus === "Abertos") {
                statusId = 0; usr = "T";
            } else if (filtroStatus === "Aguardando Retorno") {
                usr = "U";
            } else if (filtroStatus === "Aguardando Avaliação") {
                statusId = 90; usr = "X";
            } else if (filtroStatus === "Fechados") {
                statusId = 99; usr = "X";
            } else if (filtroStatus === "Cancelados") {
                statusId = 98; usr = "X";
            }

            const res = await api.get(`/chamados`, {
                params: {
                    depend: usr,
                    loja: pLoja,
                    usuario: pUser,
                    status: statusId,
                    setor: -1,
                    pagina: novaPagina,
                    limite: 15
                }
            });

            const novosChamados = Array.isArray(res.data) ? res.data : [];

            if (acumular) {
                setChamados(prev => [...prev, ...novosChamados]);
            } else {
                // AQUI É O SEGREDO: Se acumular for false, ele SUBSTITUI a lista
                // garantindo que só existam 15 na tela.
                setChamados(novosChamados);
            }

            setTemMais(novosChamados.length === 15);
            setPagina(novaPagina);

        } catch (err) {
            console.error(err);
            if (!acumular) toast.error("Erro ao carregar lista de chamados");
        } finally {
            setLoading(false);
        }
        // 🔥 REMOVA as dependências daqui para evitar loops
    }, [filtroTipo, filtroStatus, lojaSelecionada]);
    // Nota: 'chapa' geralmente é constante fora do componente, 
    // se não for, adicione-a ao array de dependências acima.

    useEffect(() => {
        carregarChamados(1, false);
    }, [carregarChamados]);

    useEffect(() => {
        setLojaSelecionada(lojaUser);
    }, []);

    useEffect(() => {
        // Só inicia o timer se houver uma chapa de usuário logado
        if (chapa) {
            const intervalo = setInterval(() => {
                setSegundosParaAtualizar((prev) => {
                    if (prev <= 1) {
                        // Chama a função que já configuramos com paginação
                        // Usamos pagina 1 e acumular false para dar o "refresh"
                        carregarChamados(1, false);
                        return 180; // Reseta para 3 minutos
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(intervalo);
        }
    }, [chapa]);




    const decodeBase64 = (str) => {
        try {
            if (!str || typeof str !== "string") return "";
            let base64 = str.replace(/\s/g, "");
            const binary = window.atob(base64);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            try {
                return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
            } catch (e) {
                return new TextDecoder("iso-8859-1").decode(bytes);
            }
        } catch (e) { return str; }
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length + anexosNovos.length > 3) {
            toast.warning("Máximo de 3 anexos permitidos");
            return;
        }

        files.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setAnexosNovos(prev => [...prev, {
                    NOME_ARQUIVO: file.name,
                    TIPO_ARQUIVO: file.type,
                    BASE64: reader.result.split(',')[1]
                }]);
            };
            reader.readAsDataURL(file);
        });
    };

    const abrirDetalhes = async (chamado) => {
        setChamadoSelecionado(chamado);
        setShowDetalhes(true);
        setLoadingDetalhes(true);

        const id = chamado.id_chamado || chamado.ID_CHAMADO;

        try {
            const resInt = await api.get(`/chamado/${id}/interacoes`);

            const interacoesComAnexos = await Promise.all(
                (resInt.data || []).map(async (i) => {
                    try {
                        const idInteracao = i.ID_INTERACAO || i.id_interacao;

                        const resAnexo = await api.get(`/chamado/anexos?id=${id}&id_interacao=${idInteracao}`);

                        return {
                            ...i,
                            ANEXOS: resAnexo.data || []
                        };
                    } catch {
                        return { ...i, ANEXOS: [] };
                    }
                })
            );

            const resAnexos = await api.get(`/chamado/anexos?id=${id}&id_interacao=0`);

            setInteracoes(interacoesComAnexos);
            setAnexosAbertura(resAnexos.data || []);
        } catch {
            setInteracoes([]);
            setAnexosAbertura([]);
        } finally {
            setLoadingDetalhes(false); // 🔥 FINALIZA LOADING
        }
    };


    const handleSubmitAvaliacao = async () => {
        if (!novaMsg.trim()) {
            toast.warning("Por favor, escreva um breve comentário sobre o atendimento.");
            return;
        }

        setEnviandoInt(true);
        try {
            const id = chamadoSelecionado.id_chamado || chamadoSelecionado.ID_CHAMADO;

            const payload = {
                id_chamado: parseInt(id),
                usuario: chapa,
                perfil: 'USUARIO',
                mensagem: novaMsg,
                status_novo: 99, // Status final com avaliação
                nota: notaAvaliacao,
                anexos: []
            };

            await api.post('/interacao', payload);

            toast.success("Avaliação enviada com sucesso!");
            setNovaMsg("");
            setShowDetalhes(false);
            carregarChamados(1, false); // Atualiza a lista principal
        } catch (err) {
            console.error(err);
            toast.error("Erro ao processar avaliação.");
        } finally {
            setEnviandoInt(false);
        }
    };

    const enviarInteracao = async () => {
        if (!novaMsg.trim() && anexosNovos.length === 0) {
            toast.warning("Digite uma mensagem ou anexe um arquivo.");
            return;
        }

        setEnviandoInt(true);

        try {
            const id = chamadoSelecionado?.id_chamado || chamadoSelecionado?.ID_CHAMADO;
            const dpSetor = (chamadoSelecionado?.dp_setor || chamadoSelecionado?.DP_SETOR || "").toString().toUpperCase();
            const statusAtual = chamadoSelecionado?.status !== undefined ? chamadoSelecionado.status : chamadoSelecionado?.STATUS;

            let statusParaEnviar = statusAtual;

            if (statusAtual === 90) {
                if (concordaSolucao === 'SIM') {
                    statusParaEnviar = 99;
                } else if (concordaSolucao === 'NAO') {
                    statusParaEnviar = 0;
                }
            } else {
                if (statusAtual < 90 && dpSetor === 'U') {
                    statusParaEnviar = 0;
                }
            }

            const payload = {
                id_chamado: parseInt(id),
                usuario: chapa,
                perfil: 'USUARIO',
                mensagem: novaMsg,
                status_novo: statusParaEnviar,
                nota: statusParaEnviar === 99 ? notaAvaliacao : null,
                anexos: anexosNovos.map(a => ({
                    nome: a.NOME_ARQUIVO || a.nome,
                    base64: a.BASE64 || a.base64
                }))
            };

            await api.post('/interacao', payload);

            // --- CONFIGURAÇÃO DO SWEETALERT2 ---
            let tituloSwal = "Enviado!";
            let textoSwal = "Sua interação foi registrada com sucesso.";
            let iconeSwal = "success";

            if (statusParaEnviar === 99) {
                tituloSwal = "Chamado Finalizado!";
                textoSwal = "Obrigado por avaliar nosso atendimento.";
            } else if (statusParaEnviar === 0 && concordaSolucao === 'NAO') {
                tituloSwal = "Chamado Reaberto!";
                textoSwal = "Sua contestação foi enviada para a equipe técnica.";
                iconeSwal = "warning";
            }

            await Swal.fire({
                title: tituloSwal,
                text: textoSwal,
                icon: iconeSwal,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            });

            // Limpeza e fechamento
            setNovaMsg("");
            setAnexosNovos([]);
            setConcordaSolucao(null);

            if (statusParaEnviar === 99 || statusParaEnviar === 0) {
                setShowDetalhes(false);
                carregarChamados(1, false);
            } else {
                abrirDetalhes(chamadoSelecionado);
            }

        } catch (err) {
            console.error(err);
            Swal.fire("Erro!", "Não foi possível salvar sua interação.", "error");
        } finally {
            setEnviandoInt(false);
        }
    };
    const isPDF = (tipo) => tipo?.toLowerCase().includes("pdf");

    useEffect(() => {
        if (pdfSelecionado?.base64) {
            const base64Limpo = pdfSelecionado.base64.split(',')[1] || pdfSelecionado.base64;
            try {
                const byteCharacters = atob(base64Limpo);
                const byteNumbers = new Uint8Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const nomeArquivo = (pdfSelecionado.nome || "").toLowerCase();

                const isTxt =
                    nomeArquivo.endsWith('.txt') ||
                    nomeArquivo.endsWith('.txt_conv');

                const tipoMime = isTxt ? 'text/plain' : 'application/pdf';

                const blob = new Blob([byteNumbers], { type: tipoMime });
                const url = URL.createObjectURL(blob);

                setUrlParaVisualizar(url);

                return () => URL.revokeObjectURL(url);
            } catch (e) {
                console.error("Erro ao converter anexo:", e);
            }
        }
    }, [pdfSelecionado]);


    const baixarArquivo = (anexo) => {
        const base64Limpo = anexo.base64.includes(',')
            ? anexo.base64.split(',')[1]
            : anexo.base64;

        const byteCharacters = atob(base64Limpo);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        const nome = (anexo.nome || "").toLowerCase();

        const isTxt =
            nome.endsWith('.txt') ||
            nome.endsWith('.txt_conv');

        const blob = new Blob([byteArray], {
            type: isTxt ? 'text/plain' : 'application/pdf'
        });

        const extensao = isTxt ? '.txt' : '.pdf';

        const nomeDownload = `CHAMADO_${chamadoSelecionado?.ID_CHAMADO || 'ANEXO'}_${anexo.nome || 'ARQUIVO'}${extensao}`;

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = nomeDownload;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div style={{ paddingTop: '80px', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Menu modulo="ARBOR" />
            <Container className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-center mb-4 mt-3">
                    <div>
                        <h4 className="fw-bold mb-0">Chamados</h4>
                        <div className="d-flex align-items-center gap-2 mt-1">
                            <small className="text-muted">Loja / Setor:</small>
                            <Form.Select
                                size="sm"
                                style={{ width: '150px' }}
                                value={lojaSelecionada}
                                onChange={(e) => setLojaSelecionada(e.target.value)}
                                disabled={filtroTipo === 'meus'}
                            >
                                {lojasPermitidas.map(loja => (
                                    <option key={loja} value={loja}>{loja}</option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>
                    <Button
                        variant="primary"
                        className="fw-bold shadow-sm d-none d-md-inline-block"
                        onClick={() => setShowNovo(true)}
                    >
                        <i className="bi bi-plus-lg me-2"></i>Novo Chamado
                    </Button>
                    <Button
                        variant="primary"
                        className="btn-floating-mobile d-md-none shadow-lg"
                        onClick={() => setShowNovo(true)}
                    >
                        <i className="bi bi-plus-lg"></i>
                    </Button>
                </div>

                <div className="d-flex flex-column align-items-center mb-4 gap-3">
                    <ButtonGroup className="shadow-sm bg-white p-1 rounded-pill d-flex justify-content-center w-100">
                        {['loja', 'meus'].map((tipo) => (
                            <ToggleButton
                                key={tipo}
                                type="radio"
                                variant="outline-primary"
                                className="rounded-pill border-0 px-4"
                                value={tipo}
                                checked={filtroTipo === tipo}
                                onClick={() => setFiltroTipo(tipo)}
                                onChange={() => { }}
                            >
                                {tipo === 'loja' ? 'Minha Loja' : 'Meus Chamados'}
                            </ToggleButton>
                        ))}
                    </ButtonGroup>

                    {/* Container com scroll horizontal para os status */}
                    <div className="status-container-scroll w-100">
                        <ButtonGroup size="sm" className="shadow-sm bg-white p-1 rounded-pill mb-2">
                            {["Todos", "Abertos", "Aguardando Retorno", "Aguardando Avaliação", "Fechados", "Cancelados"].map((st) => (
                                <ToggleButton
                                    key={st}
                                    type="radio"
                                    variant="outline-secondary"
                                    className="rounded-pill border-0 px-3 text-nowrap" // Adicionado text-nowrap
                                    value={st}
                                    checked={filtroStatus === st}
                                    onClick={() => setFiltroStatus(st)}
                                    onChange={() => { }}
                                >
                                    {st}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>
                ) : (
                    <Row>
                        {chamados.map(c => (
                            <Col md={4} key={c.id_chamado || c.ID_CHAMADO} className="mb-4">
                                <Card className="h-100 shadow-sm border-0" onClick={() => abrirDetalhes(c)} style={{ cursor: 'pointer', borderRadius: '12px' }}>
                                    <div style={{ height: '6px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', backgroundColor: c.cor_hex || c.COR_HEX || '#0dcaf0' }} />
                                    <Card.Body>
                                        <div className="d-flex justify-content-between mb-2">
                                            <Badge style={{ backgroundColor: c.cor_hex || c.COR_HEX || '#0dcaf0' }}>{c.status_nome || c.STATUS_NOME}
                                                {c.nota_avaliacao > 0 && c.status === 99 ? (
                                                    <span>
                                                        <b> - Nota: </b>
                                                        {c.nota_avaliacao || c.NOTA_AVALIACAO}
                                                    </span>
                                                ) : null}
                                            </Badge>
                                            <div className="text-muted small">#{c.id_chamado || c.ID_CHAMADO}</div>
                                        </div>
                                        <Card.Title className="h6 fw-bold text-dark">{c.assunto || c.ASSUNTO}</Card.Title>
                                        <div className="bg-light p-2 rounded small mb-2" style={{ fontSize: '0.75rem' }}>
                                            <div><strong>Setor:</strong> {c.nome_setor || c.NOME_SETOR}</div>
                                            <div><strong>Loja:</strong> {String(c.loja).padStart(2, '0') || String(c.LOJA).padStart(2, '0')}</div>
                                            <div className="mt-1 text-primary">
                                                <i className="bi bi-clock me-1"></i>{formatarData(c.data_abertura || c.DATA_ABERTURA)}
                                            </div>
                                        </div>
                                        <Card.Text className="small text-muted text-truncate">{decodeBase64(c.descricao || c.DESCRICAO)}</Card.Text>
                                        {c.ultima_data_interacao && (
                                            <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '5px' }}>
                                                <i className="bi bi-reply-all me-1"></i>
                                                <b>Última resposta: </b>{formatarData(c.ultima_data_interacao)} - <b>Usuário: </b>{formatarNomePrimeiro(c.ultima_nome_interacao)}
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>



                )}
                {temMais && (
                    <div className="d-flex justify-content-center my-4">
                        <Button
                            variant="outline-primary"
                            // Passa a próxima página e diz que deve 'acumular' (true)
                            onClick={() => carregarChamados(pagina + 1, true)}
                            disabled={loading}
                        >
                            {loading ? "Carregando..." : "Ver mais chamados"}
                        </Button>
                    </div>
                )}

            </Container>

            <Modal show={showDetalhes} onHide={() => setShowDetalhes(false)} size="lg" centered contentClassName="border-0 shadow-lg">
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title className="h6">#{chamadoSelecionado?.id_chamado || chamadoSelecionado?.ID_CHAMADO} - {chamadoSelecionado?.assunto || chamadoSelecionado?.ASSUNTO}</Modal.Title>
                </Modal.Header>
                <div style={{ height: '6px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', backgroundColor: chamadoSelecionado?.cor_hex || chamadoSelecionado?.COR_HEX || '#0dcaf0' }} />

                <Modal.Body ref={scrollRef} style={{ backgroundColor: '#e5ddd5', height: '65vh', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
                    {/* BLOCO DE ABERTURA CUSTOMIZADO */}

                    <div className="d-flex justify-content-start mb-4">
                        <div className="shadow-sm p-3" style={{
                            borderRadius: '0 15px 15px 15px',
                            maxWidth: '85%',
                            backgroundColor: '#ffffff'
                        }}>

                            <div className="border-bottom border-dark border-opacity-10 mb-2 pb-1">

                                {/* LINHA 1: NOME + STATUS */}
                                <div className="d-flex align-items-center gap-2">
                                    <span className="fw-bold small text-primary">
                                        {formatarNomePrimeiro(chamadoSelecionado?.nome_usuario || chamadoSelecionado?.NOME_USUARIO)}
                                    </span>

                                    <span
                                        style={{
                                            fontSize: '0.6rem',
                                            padding: '2px 6px',
                                            borderRadius: '8px',
                                            /*backgroundColor: (chamadoSelecionado?.cor_hex || chamadoSelecionado?.COR_HEX || '#6c757d') + '20',
                                            color: chamadoSelecionado?.cor_hex || chamadoSelecionado?.COR_HEX || '#6c757d',*/
                                            fontWeight: 600
                                        }}
                                    >
                                        {chamadoSelecionado?.status_nome || chamadoSelecionado?.STATUS_NOME}
                                    </span>
                                </div>
                            </div>

                            <div className="small mb-2 text-dark">
                                <strong>Setor:</strong> {chamadoSelecionado?.nome_setor || chamadoSelecionado?.NOME_SETOR} <br />
                                <strong>Loja:</strong> {String(chamadoSelecionado?.loja).padStart(2, '0') || String(chamadoSelecionado?.LOJA).padStart(2, '0')} <br />
                                <strong>Categoria:</strong> {chamadoSelecionado?.categoria_nome || chamadoSelecionado?.CATEGORIA_NOME}
                            </div>

                            <div className="small text-dark mb-2" style={{ whiteSpace: 'pre-wrap' }}>
                                {decodeBase64(chamadoSelecionado?.descricao || chamadoSelecionado?.DESCRICAO)}
                            </div>

                            {anexosAbertura.length > 0 && (
                                <Row className="g-1">
                                    {anexosAbertura.map((f, i) => {
                                        const nomeArquivo = (f.NOME_ARQUIVO || f.nome || "").toLowerCase();
                                        let base64 = (f.BASE64 || f.base64 || "").replace(/\r?\n|\r/g, "");

                                        const isPDF = nomeArquivo.endsWith(".pdf");
                                        const isPNG = nomeArquivo.endsWith(".png");
                                        const isTXT = nomeArquivo.endsWith('.txt') || nomeArquivo.endsWith('.txt_conv');

                                        let mimeType = isPNG ? "image/png" : (isPDF ? "application/pdf" : (isTXT ? "text/plain" : "image/jpeg"));

                                        return (
                                            <Col xs={4} key={i}>
                                                <div
                                                    className="ratio ratio-1x1 border rounded overflow-hidden bg-white d-flex align-items-center justify-content-center"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        // 🔥 AQUI ESTAVA O ERRO: Adicionamos isTXT na condição
                                                        if (isPDF || isTXT) {
                                                            setPdfSelecionado({ base64, nome: nomeArquivo });
                                                        } else {
                                                            setFotoSelecionada({
                                                                foto: `data:${isPNG ? 'image/png' : 'image/jpeg'};base64,${base64}`,
                                                                nome: nomeArquivo
                                                            });
                                                        }
                                                    }}
                                                >
                                                    {/* 🔥 SELEÇÃO DO ÍCONE OU IMAGEM */}
                                                    {isPDF ? (
                                                        <div className="text-center text-danger fw-bold">
                                                            <i className="bi bi-file-earmark-pdf fs-1"></i>
                                                            <div style={{ fontSize: '0.7rem' }}>PDF</div>
                                                        </div>
                                                    ) : isTXT ? (
                                                        <div className="text-center text-primary fw-bold">
                                                            <i className="bi bi-file-earmark-text fs-1"></i>
                                                            <div style={{ fontSize: '0.7rem' }}>TEXTO</div>
                                                        </div>
                                                    ) : (
                                                        <img
                                                            src={`data:${mimeType};base64,${base64}`}
                                                            alt="anexo"
                                                            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                                        />
                                                    )}
                                                </div>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            )}
                            {/* LINHA 2: DATA */}
                            <div className="text-end">
                                <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                                    {formatarData(chamadoSelecionado?.data_abertura || chamadoSelecionado?.DATA_ABERTURA)}
                                </small>
                            </div>
                        </div>
                    </div>

                    {/* INTERAÇÕES - CORREÇÃO DOS ANEXOS AQUI */}
                    {interacoes.map((i, idx) => {
                        const usuarioInteracao = i.CHAPA || i.USUARIO || i.usuario || i.chapa;
                        const isMe = String(usuarioInteracao).trim() === String(chapa).trim();
                        // Garante que pegamos os anexos independente da caixa (ANEXOS ou anexos)
                        const listAnexos = i.ANEXOS || i.anexos || [];

                        return (
                            <div
                                key={idx}
                                style={{
                                    display: 'flex',
                                    justifyContent: isMe ? 'flex-end' : 'flex-start',
                                    paddingLeft: isMe ? '40px' : '8px',
                                    paddingRight: isMe ? '8px' : '40px',
                                    marginBottom: '6px'
                                }}
                            >
                                <div
                                    className="position-relative"
                                    style={{
                                        borderRadius: isMe
                                            ? '12px 12px 4px 12px'
                                            : '12px 12px 12px 4px',
                                        backgroundColor: isMe ? '#dcf8c6' : '#ffffff',
                                        maxWidth: '65%',
                                        padding: '6px 8px',
                                        boxShadow: '0 1px 1px rgba(0,0,0,0.08)',
                                        display: 'inline-block'
                                    }}
                                >
                                    {/* Rabinho */}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            bottom: 0,
                                            [isMe ? 'right' : 'left']: -6,
                                            width: 0,
                                            height: 0,
                                            borderTop: '6px solid transparent',
                                            borderBottom: '6px solid transparent',
                                            borderLeft: isMe ? '6px solid #dcf8c6' : 'none',
                                            borderRight: !isMe ? '6px solid #ffffff' : 'none'
                                        }}
                                    />
                                    <div className="d-flex align-items-center gap-1 mb-1" style={{ fontSize: '0.7rem' }}>
                                        <span className={`fw-bold ${isMe ? 'text-success' : 'text-primary'}`}>
                                            {isMe ? 'Você' : formatarNomePrimeiro(i.NOME_USUARIO || i.nome_usuario)}
                                        </span>

                                        <span
                                            style={{
                                                fontSize: '0.55rem',
                                                padding: '1px 5px',
                                                borderRadius: '6px',
                                                backgroundColor: (i.COR_HEX || i.cor_hex || '#6c757d') + '15',
                                                color: i.COR_HEX || i.cor_hex || '#6c757d',
                                                fontWeight: 500
                                            }}
                                        >
                                            {i.STATUS_NOME || i.status_nome}
                                        </span>
                                    </div>

                                    <div
                                        style={{
                                            fontSize: '0.8rem',
                                            color: '#111',
                                            whiteSpace: 'pre-wrap',
                                            lineHeight: '1.3'
                                        }}
                                    >
                                        {decodeBase64(i.MENSAGEM || i.mensagem)}
                                    </div>

                                    {/* Exibição Corrigida de Anexos das Interações */}
                                    {listAnexos.length > 0 && (
                                        <Row className="g-1 mt-2">
                                            {listAnexos.map((f, k) => {
                                                const nomeArquivo = (f.nome || f.NOME_ARQUIVO || "").toLowerCase();
                                                let base64 = f.base64 || f.BASE64 || "";

                                                // LIMPA QUEBRAS DE LINHA DO BASE64 (ESSENCIAL)
                                                base64 = base64.replace(/\r?\n|\r/g, "");

                                                // Detecta tipo pelo nome
                                                const isPDFFile = nomeArquivo.endsWith(".pdf");
                                                const isTXT = nomeArquivo.endsWith(".txt") || nomeArquivo.endsWith(".txt_conv");
                                                const isPNG = nomeArquivo.endsWith(".png");
                                                const isJPG = nomeArquivo.endsWith(".jpg") || nomeArquivo.endsWith(".jpeg");

                                                let mimeType = "image/jpeg";

                                                if (isPNG) mimeType = "image/png";
                                                else if (isPDFFile) mimeType = "application/pdf";
                                                else if (isTXT) mimeType = "text/plain";

                                                return (
                                                    <Col xs={4} key={k}>
                                                        <div
                                                            className="ratio ratio-1x1 border rounded overflow-hidden bg-white"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                if (isPDFFile || isTXT) {
                                                                    setPdfSelecionado({
                                                                        base64: base64,
                                                                        nome: nomeArquivo
                                                                    });
                                                                } else {
                                                                    const mimeTypeFinal = isPNG ? 'image/png' : 'image/jpeg';
                                                                    setFotoSelecionada({
                                                                        foto: `data:${mimeTypeFinal};base64,${base64}`,
                                                                        nome: nomeArquivo
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            {isPDFFile ? (
                                                                <div className="d-flex align-items-center justify-content-center small text-center p-1 bg-light text-danger fw-bold">
                                                                    <i className="bi bi-file-earmark-pdf"></i>
                                                                    <div style={{ fontSize: '0.7rem' }}>PDF</div>
                                                                </div>
                                                            ) : isTXT ? (
                                                                <div className="d-flex align-items-center justify-content-center small text-center p-1 bg-light text-primary fw-bold">
                                                                    <i className="bi bi-file-earmark-text"></i>
                                                                    <div style={{ fontSize: '0.7rem' }}>TEXTO</div>
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={`data:${mimeType};base64,${base64}`}
                                                                    alt="anexo"
                                                                    style={{ objectFit: 'cover' }}
                                                                />
                                                            )}
                                                        </div>
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    )}
                                    {chamadoSelecionado?.nota_avaliacao > 0 & i.status_novo === 99 ? (
                                        <div className="d-flex justify-content-between mb-2">
                                            <Badge style={{ backgroundColor: chamadoSelecionado?.cor_hex || chamadoSelecionado?.COR_HEX || '#0dcaf0' }}><b>Nota: </b>{chamadoSelecionado?.nota_avaliacao}</Badge>

                                        </div>
                                    ) : ""}

                                    <div className="text-end mt-1" style={{ opacity: 0.6 }}>
                                        <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                                            {i.descricao} - {formatarData(i.DATA_INTEGRACAO || i.data_interacao)}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    {loadingDetalhes && (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                            <div className="text-center">
                                <Spinner animation="border" variant="primary" />
                                <div className="mt-2 text-muted small">Carregando interações...</div>
                            </div>
                        </div>
                    )}
                </Modal.Body>

                {/* Substitua a partir da div que começa após o Modal.Body */}
                <div className="p-3 border-top bg-white">
                    {/* LOGICA DE REABERTURA OU AVALIAÇÃO */}
                    {(chamadoSelecionado?.STATUS === 90 || chamadoSelecionado?.status === 90) &&
                        (chamadoSelecionado?.DP_SETOR === 'X' || chamadoSelecionado?.dp_setor === 'X') &&
                        !chamadoSelecionado?.NOTA_AVALIACAO && concordaSolucao !== 'NAO' ? (

                        <div className="p-2 border rounded bg-light shadow-sm">
                            {concordaSolucao === null ? (
                                /* PASSO 1: PERGUNTA SE CONCORDA */
                                <div className="text-center py-2">
                                    <h6 className="mb-3 fw-bold text-dark">Você concorda com a solução apresentada?</h6>
                                    <div className="d-flex gap-2 justify-content-center">
                                        <Button
                                            variant="outline-danger"
                                            className="px-4"
                                            onClick={() => setConcordaSolucao('NAO')}
                                        >
                                            <i className="bi bi-hand-thumbs-down me-2"></i>Não, Reabrir
                                        </Button>
                                        <Button
                                            variant="success"
                                            className="px-4"
                                            onClick={() => setConcordaSolucao('SIM')}
                                        >
                                            <i className="bi bi-hand-thumbs-up me-2"></i>Sim, Avaliar
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                /* PASSO 2 (SIM): FORMULÁRIO DE NOTA (COMPACTO) */
                                <div>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <span className="small fw-bold text-success">Avalie o Atendimento (Nota: {notaAvaliacao})</span>
                                        <Button variant="link" size="sm" className="p-0 text-decoration-none" onClick={() => setConcordaSolucao(null)}>Voltar</Button>
                                    </div>
                                    <Row className="align-items-center g-2">
                                        <Col xs={5}>
                                            <Form.Range
                                                min={1} max={10} value={notaAvaliacao}
                                                onChange={(e) => setNotaAvaliacao(Number(e.target.value))}
                                            />
                                        </Col>
                                        <Col xs={5}>
                                            <Form.Control
                                                size="sm"
                                                placeholder="Comentário..."
                                                value={novaMsg}
                                                onChange={(e) => setNovaMsg(e.target.value)}
                                            />
                                        </Col>
                                        <Col xs={2}>
                                            <Button
                                                variant="success" size="sm" className="w-100"
                                                onClick={enviarInteracao} // Chamada unificada
                                                disabled={!novaMsg.trim() || enviandoInt}
                                            >
                                                {enviandoInt ? <Spinner size="sm" /> : <i className="bi bi-check-lg"></i>}
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </div>

                    ) : (
                        /* AREA DE TEXTO ESTILO WHATSAPP (CHAT NORMAL / REABERTURA) */
                        <>
                            {concordaSolucao === 'NAO' && (
                                <div className="alert alert-danger py-1 px-2 mb-2 d-flex justify-content-between align-items-center" style={{ fontSize: '0.8rem' }}>
                                    <span><strong>Modo Reabertura:</strong> Justifique e anexe arquivos se necessário.</span>
                                    <Button variant="link" size="sm" className="p-0 text-danger fw-bold" onClick={() => setConcordaSolucao(null)}>Cancelar</Button>
                                </div>
                            )}

                            {anexosNovos.length > 0 && (
                                <div className="d-flex flex-wrap gap-2 mb-2">
                                    {anexosNovos.map((a, idx) => (
                                        <Badge key={idx} bg="info" className="d-flex align-items-center p-2">
                                            <i className="bi bi-paperclip me-1"></i>
                                            {a.NOME_ARQUIVO.substring(0, 15)}...
                                            <i className="bi bi-x-circle ms-2" style={{ cursor: 'pointer' }} onClick={() => setAnexosNovos(prev => prev.filter((_, i) => i !== idx))}></i>
                                        </Badge>
                                    ))}
                                </div>
                            )}

                            <div className="mt-1">
                                <InputGroup className={`shadow-sm border rounded-3 overflow-hidden ${(chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X") && concordaSolucao !== 'NAO' ? 'bg-light' : ''}`}>
                                    <input type="file" id="fileInt" hidden multiple onChange={handleFileChange} accept="image/*,application/pdf" />
                                    <Button
                                        variant="light"
                                        className="bg-white border-0 px-3"
                                        onClick={() => document.getElementById('fileInt').click()}
                                        disabled={(chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X") && concordaSolucao !== 'NAO'}
                                    >
                                        <i className="bi bi-paperclip fs-5 text-secondary"></i>
                                    </Button>

                                    <Form.Control
                                        className="border-0 shadow-none py-2"
                                        placeholder={
                                            concordaSolucao === 'NAO'
                                                ? "Descreva o motivo da reabertura..."
                                                : (chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X")
                                                    ? "Este chamado foi finalizado!"
                                                    : "Escreva sua mensagem..."
                                        }
                                        value={novaMsg}
                                        onChange={(e) => setNovaMsg(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && enviarInteracao()} // Ajustado aqui
                                        disabled={((chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X") && concordaSolucao !== 'NAO') || enviandoInt}
                                    />

                                    <Button
                                        variant={concordaSolucao === 'NAO' ? "danger" : "primary"}
                                        className="px-4 border-0"
                                        onClick={enviarInteracao} // Ajustado aqui (apenas a referência)
                                        disabled={enviandoInt || ((chamadoSelecionado?.dp_setor === "X" || chamadoSelecionado?.DP_SETOR === "X") && concordaSolucao !== 'NAO') || (!novaMsg.trim() && anexosNovos.length === 0)}
                                    >
                                        {enviandoInt ? <Spinner size="sm" /> : concordaSolucao === 'NAO' ? "Reabrir" : <i className="bi bi-send-fill"></i>}
                                    </Button>
                                </InputGroup>
                            </div>
                        </>
                    )}
                </div>

            </Modal >

            <ModalNovoChamado
                show={showNovo}
                onHide={() => setShowNovo(false)}
                loja={lojaSelecionada} // Garanta que esta variável tem o código da loja (ex: 1, 2, 10...)
                onSuccess={() => {
                    setShowNovo(false);
                    carregarChamados(1, false);
                }}
            />
            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01=""
                info02=""
            />


            {/* MODAL PDF */}
            <Modal
                show={!!pdfSelecionado}
                onHide={() => {
                    setPdfSelecionado(null);
                    setFullscreenPdf(false);
                }}
                size="lg"
            >
                <Modal.Header closeButton className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1 }}>
                        <strong
                            className="text-primary text-truncate"
                            style={{
                                fontSize: '0.9rem',
                                maxWidth: '100%',
                                display: 'block'
                            }}
                            title={pdfSelecionado?.nome}
                        >
                            {pdfSelecionado?.nome}
                        </strong>
                    </div>

                    <Button
                        variant="outline-primary"
                        size="sm"
                        className="ms-2 flex-shrink-0"
                        onClick={() => setFullscreenPdf(true)}
                        style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}
                    >
                        <i className="bi bi-arrows-fullscreen"></i>
                        <span className="d-none d-md-inline ms-1">Fullscreen</span>
                    </Button>
                </Modal.Header>

                <Modal.Body style={{ height: '75vh', p: 0, display: 'flex', flexDirection: 'column' }}>
                    {urlParaVisualizar ? (
                        <>
                            {/* Barra de ferramentas com botão de Download */}
                            <div className="d-flex justify-content-end p-2 bg-light border-bottom">
                                <Button
                                    variant="primary"
                                    size="sm"
                                    onClick={() => {
                                        const link = document.createElement('a');
                                        link.href = urlParaVisualizar;
                                        link.download = pdfSelecionado?.nome || "arquivo";
                                        link.click();
                                    }}
                                >
                                    <i className="bi bi-download"></i> Baixar Arquivo
                                </Button>
                            </div>

                            <iframe
                                src={urlParaVisualizar} // 🔥 IMPORTANTE: Use a URL do Blob
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                                title="Visualizador"
                            />
                        </>
                    ) : (
                        <div className="text-center p-5">Carregando visualização...</div>
                    )}
                </Modal.Body>
            </Modal>

            <PdfFullscreen
                pdf={urlParaVisualizar} // 🔥 Deve ser urlParaVisualizar
                nome={pdfSelecionado?.nome}
                fullscreen={fullscreenPdf}
                setFullscreen={setFullscreenPdf}
            />

            {/* Timer Flutuante Transparente */}
            {/* Timer Flutuante para o Usuário */}
            <div
                style={{
                    position: 'fixed',
                    bottom: '40px',
                    right: '20px',
                    backgroundColor: 'rgba(33, 37, 41, 0.6)', // Cor escura transparente (Bootstrap Dark)
                    color: '#fff',
                    padding: '6px 14px',
                    borderRadius: '50px',
                    fontSize: '0.75rem',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(5px)',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                }}
            >
                <Spinner
                    animation="border"
                    size="sm"
                    className="me-2"
                    style={{ width: '12px', height: '12px', borderWidth: '2px' }}
                />
                <span>
                    Atualizando em {Math.floor(segundosParaAtualizar / 60)}:
                    {String(segundosParaAtualizar % 60).padStart(2, '0')}
                </span>
            </div>
            <Footer />
        </div >
    );
}

export default CentralChamados;